const windData = [
  {
    name: "北风",
    vuale: [0, 11.25],
  },
  {
    name: "北风",
    vuale: [348.76, 360],
  },
  {
    name: "东北风",
    vuale: [11.26, 33.75],
  },
  {
    name: "东北风",
    vuale: [33.76, 56.25],
  },
  {
    name: "东北风",
    vuale: [56.26, 78.75],
  },
  {
    name: "东风",
    vuale: [78.76, 101.25],
  },
  {
    name: "东南风",
    vuale: [101.26, 123.75],
  },
  {
    name: "东南风",
    vuale: [123.76, 146.25],
  },
  {
    name: "东南风",
    vuale: [146.26, 168.75],
  },
  {
    name: "南风",
    vuale: [168.76, 191.25],
  },

  {
    name: "西南风",
    vuale: [191.26, 213.75],
  },
  {
    name: "西南风",
    vuale: [213.76, 236.25],
  },
  {
    name: "西南风",
    vuale: [236.26, 258.75],
  },
  {
    name: "西风",
    vuale: [258.76, 281.25],
  },
  {
    name: "西北风",
    vuale: [281.26, 303.75],
  },
  {
    name: "西北风",
    vuale: [303.76, 336.25],
  },
  {
    name: "西北风",
    vuale: [336.26, 348.75],
  },
];
export function findWind(num) {
  const item = windData.find(
    (item) => num >= item.vuale[0] && num <= item.vuale[1],
  );
  if (item && item.name) {
    return item.name;
  } else {
    return "";
  }
}

/**
 * 获取两个经纬度之间的距离
 * @param lat1 第一点的纬度
 * @param lng1 第一点的经度
 * @param lat2 第二点的纬度
 * @param lng2 第二点的经度
 * @returns {Number}
 */

export function getDistance(lat1, lng1, lat2, lng2) {
  lat1 = Number(lat1);
  lng1 = Number(lng1);
  lat2 = Number(lat2);
  lng2 = Number(lng2);
  console.log(lat1, lng1, lat2, lng2);
  var f = getRad((lat1 + lat2) / 2);
  var g = getRad((lat1 - lat2) / 2);
  var l = getRad((lng1 - lng2) / 2);
  var sg = Math.sin(g);
  var sl = Math.sin(l);
  var sf = Math.sin(f);
  var s, c, w, r, d, h1, h2;
  var a = 6378137.0; // The Radius of eath in meter.
  var fl = 1 / 298.257;
  sg = sg * sg;
  sl = sl * sl;
  sf = sf * sf;
  s = sg * (1 - sl) + (1 - sf) * sl;
  c = (1 - sg) * (1 - sl) + sf * sl;
  w = Math.atan(Math.sqrt(s / c));
  r = Math.sqrt(s * c) / w;
  d = 2 * w * a;
  h1 = (3 * r - 1) / 2 / c;
  h2 = (3 * r + 1) / 2 / s;
  s = d * (1 + fl * (h1 * sf * (1 - sg) - h2 * (1 - sf) * sg));
  s = s / 1000;
  s = s.toFixed(2); // 指定小数点后的位数。
  return s;
}

function getRad(d) {
  var PI = Math.PI;
  return (d * PI) / 180.0;
}

/**
 *
 * @param l 风力参数值
 * @returns
 */
export function getWindforce(l) {
  if (l === null || l === undefined || isNaN(l)) return "";
  if (l <= 0.3) return 0;
  else if (l <= 1.5) return 1;
  else if (l <= 3.3) return 2;
  else if (l <= 5.4) return 3;
  else if (l <= 7.9) return 4;
  else if (l <= 10.7) return 5;
  else if (l <= 13.8) return 6;
  else if (l <= 17.1) return 7;
  else if (l <= 20.7) return 8;
  else if (l <= 24.4) return 9;
  else if (l <= 28.4) return 10;
  else if (l <= 32.6) return 11;
  else if (l <= 36.9) return 12;
  else if (l <= 41.4) return 13;
  else if (l <= 46.1) return 14;
  else if (l <= 50.9) return 15;
  else if (l <= 56.0) return 16;
  else if (l <= 61.2) return 17;
  else return 17;
}
